import { Component, inject } from '@angular/core';
import { Router } from "@angular/router";
import { NzMessageService } from "ng-zorro-antd/message";

@Component({
  selector: 'app-not-found-redirect',
  template: '',
})
export class NotFoundRedirectComponent {
  private router = inject(Router);
  private messageService = inject(NzMessageService);

  constructor() {
    this.messageService.error('Путь не найден', {
      nzDuration: 5000,
    });
    this.router.navigate(['/tasks']);
  }

}
